import type { CardDefinition, CardType, CardRarity } from '@/types/card';

export const CARD_DEFINITIONS: Record<CardType, CardDefinition> = {
  freeze: {
    type: 'freeze',
    name: 'Freeze',
    description: 'All enemies skip their next 2 turns.',
    icon: 'effects',
    rarity: 'common',
  },
  warp: {
    type: 'warp',
    name: 'Warp',
    description: 'Teleport to any reachable stop tile.',
    icon: 'portal',
    rarity: 'rare',
  },
  scout: {
    type: 'scout',
    name: 'Scout',
    description: 'Highlights the path to exit for 3 moves.',
    icon: 'eye',
    rarity: 'common',
  },
  shield: {
    type: 'shield',
    name: 'Shield',
    description: 'Grants a one-hit shield against enemies.',
    icon: 'shield',
    rarity: 'rare',
  },
  rewind: {
    type: 'rewind',
    name: 'Rewind',
    description: 'Undo the last 3 moves for you and all enemies.',
    icon: 'undo',
    rarity: 'epic',
  },
};

export const DROP_RATES: Record<CardRarity | 'nothing', number> = {
  common: 0.60,
  rare: 0.25,
  epic: 0.05,
  nothing: 0.10,
};

export const MAX_HAND_SIZE = 3;
export const MAX_INVENTORY_SIZE = 12;

export const RARITY_COLORS: Record<CardRarity, string> = {
  common: '#777',
  rare: '#3b82f6',
  epic: '#a855f7',
};

export const SHOP_CARD_PRICES = {
  randomPack: { cost: 150, currency: 'coins' as const, count: 3 },
  specificCommon: { cost: 5, currency: 'gems' as const },
  specificRare: { cost: 15, currency: 'gems' as const },
  specificEpic: { cost: 40, currency: 'gems' as const },
};
